(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class RealStoriesCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.real-stories__track');
      this.slides = Array.from(this.querySelectorAll('.real-stories__slide'));
      this.prevButton = this.querySelector('[data-real-stories-prev]');
      this.nextButton = this.querySelector('[data-real-stories-next]');
      if (!this.track || this.slides.length === 0) return;

      this.onScroll = this.onScroll.bind(this);
      this.prevButton?.addEventListener('click', () => this.go(-1));
      this.nextButton?.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }

    step() {
      const trackStyle = getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      return this.slides[0].getBoundingClientRect().width + gap;
    }

    go(direction) {
      const behavior = reducedMotion.matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: direction * this.step(), behavior });
    }

    onScroll() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 8;
      const atEnd = this.track.scrollLeft >= maxScroll - 8;
      if (this.prevButton) this.prevButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd || maxScroll <= 0;
    }
  }

  customElements.define('real-stories-carousel', RealStoriesCarousel);
})();
